import { useRef } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useAppSelector } from '@store';
import { Table, PermissionDenied, PermissionEnum } from '@ui/src';
import { columns, columnsLabels } from '../variables/devices';

import useDevicesList from '../hooks/use-devices-list';

import cn from '../styles.module.css';

const IndividualCustomerDevices = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const { activePermissions } = useAppSelector((state) => state.root);
  const { devices, takeCount, pagination, errorsList } = useAppSelector(
    (state) => state.individualCustomers.info.devices,
  );

  const { customerId } = useParams();

  const {
    formattedData,
    filters,
    filtersComponent,
    handleSubmit,
    isLoading,
    isFetching,
    errorList,
    setPage,
  } = useDevicesList({
    customerId,
    devices,
    activePermissions,
    scrollRef,
    takeCount,
  });

  let content;

  if (!activePermissions?.includes(PermissionEnum.CUSTOMERS_DEVICES_LIST)) {
    content = <PermissionDenied />;
  } else {
    content = (
      <Table
        columns={columns}
        data={formattedData || []}
        onSort={() => {}}
        filters={filters}
        sort={{}}
        columnsLabels={columnsLabels}
        tableClassName={!devices?.length ? cn.devicesEmpty : ''}
        tableTopClassName={cn.devicesTableTop}
        onFilterChange={() => {}}
        filtersComponent={filtersComponent}
        handleSubmit={handleSubmit}
        isLoading={isLoading || isFetching}
        take={takeCount?.toString()}
        error={errorsList || errorList}
        setPage={(data) => {
          setPage({
            ...data,
            filters: {
              ...filters,
            },
          });
        }}
        pagination={pagination}
        clickable
        withScroll
      />
    );
  }

  return (
    <div className={cn.devicesContent} ref={scrollRef}>
      {content}
      <Outlet />
    </div>
  );
};

export default IndividualCustomerDevices;
